// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Hooks = require("../../../utils/Hooks.bs.js");
let React = require("react");
let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let Loader = require("../../../uikit/reason/atoms/Loader/Loader.bs.js");
let MenuV5 = require("../../common/Components/menu/MenuV5.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let ReadMoreButton = require("../../../components/buttons/ReadMoreButton.bs.js");
let QuestionPopover = require("../../../components/MyClientsWidget/components/QuestionPopover/QuestionPopover.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let MyClientsWidgetBuyer = require("./MyClientsWidgetBuyer.bs.js");
let MyClientsWidgetRenter = require("./MyClientsWidgetRenter.bs.js");
let MyClientsWidgetSeller = require("./MyClientsWidgetSeller.bs.js");
let VisuallyHidden = require("@reach/visually-hidden").default;
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let MyClientsWidgetLandlord = require("./MyClientsWidgetLandlord.bs.js");
let MyClientsWidgetRelay_query_graphql = require("../../../__generated__/MyClientsWidgetRelay_query_graphql.bs.js");
let MyClientsWidgetRelayPaginationQuery_graphql = require("../../../__generated__/MyClientsWidgetRelayPaginationQuery_graphql.bs.js");

function MyClientsWidgetRelay$AddClientMenu(props) {
  let button = Hooks.useResponsive(JsxRuntime.jsxs(ButtonsV5.SecondaryButton.make, {
    size: "small",
    children: [
      JsxRuntime.jsx(IconV5.make, {
        icon: "add",
        size: 14
      }),
      JsxRuntime.jsx(VisuallyHidden, {
        children: "Add client"
      })
    ]
  }), JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
    size: "small",
    children: "Add Client"
  }), undefined, undefined, undefined, undefined, undefined);
  return JsxRuntime.jsxs(MenuV5.Menu.make, {
    button: button,
    children: [
      JsxRuntime.jsx(MenuV5.MenuItem.make, {
        href: "/sellers/new",
        children: "Add seller quietly"
      }),
      JsxRuntime.jsx(MenuV5.MenuItem.make, {
        href: "/properties/new",
        children: "Broadcast a property"
      }),
      JsxRuntime.jsx(MenuV5.MenuItem.make, {
        href: "/private_buyers/new",
        children: "Add buyer quietly"
      }),
      JsxRuntime.jsx(MenuV5.MenuItem.make, {
        href: "/client_needs/new",
        children: "Broadcast a buyer or rental need"
      })
    ]
  });
}

let AddClientMenu = {
  make: MyClientsWidgetRelay$AddClientMenu
};

let getConnectionNodes = MyClientsWidgetRelay_query_graphql.Utils.getConnectionNodes;

let convertFragment = MyClientsWidgetRelay_query_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetRelay_query_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetRelay_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetRelay_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetRelay_query_graphql.node, convertFragment, fRef);
}

let makeRefetchVariables = MyClientsWidgetRelayPaginationQuery_graphql.Types.makeRefetchVariables;

let convertRefetchVariables = MyClientsWidgetRelayPaginationQuery_graphql.Internal.convertVariables;

function useRefetchable(fRef) {
  return RescriptRelay_Fragment.useRefetchableFragment(MyClientsWidgetRelay_query_graphql.node, convertFragment, convertRefetchVariables, fRef);
}

function usePagination(fRef) {
  return RescriptRelay_Fragment.usePaginationFragment(MyClientsWidgetRelay_query_graphql.node, fRef, convertFragment, convertRefetchVariables);
}

let QueryFragment = {
  getConnectionNodes: getConnectionNodes,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment,
  makeRefetchVariables: makeRefetchVariables,
  convertRefetchVariables: convertRefetchVariables,
  useRefetchable: useRefetchable,
  usePagination: usePagination
};

function MyClientsWidgetRelay$Layout(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h2", {
                children: "My Clients",
                className: "text-gray-700 text-2xl font-medium"
              }),
              JsxRuntime.jsxs(QuestionPopover.make, {
                children: [
                  "Keep track of your clients and activity on TAN.",
                  " ",
                  JsxRuntime.jsx("a", {
                    children: "Read more.",
                    href: "https://intercom.help/top-agent-network/faqs-and-troubleshooting/my-clients",
                    target: "_blank"
                  })
                ]
              })
            ],
            className: "flex flex-row items-center gap-4"
          }),
          JsxRuntime.jsx(MyClientsWidgetRelay$AddClientMenu, {})
        ],
        className: "flex flex-row pb-[15px] items-center justify-between"
      }),
      props.children
    ],
    className: "bg-white p-5 rounded shadow-sm"
  });
}

let Layout = {
  make: MyClientsWidgetRelay$Layout
};

function MyClientsWidgetRelay$EmptyState(props) {
  return JsxRuntime.jsx("div", {
    children: "When you add your clients to TAN, they'll appear here. This makes it easy to track your clients, edit posts and evaluate matches.",
    className: "p-5 border border-gray-300 text-base leading-5 rounded"
  });
}

let EmptyState = {
  make: MyClientsWidgetRelay$EmptyState
};

function MyClientsWidgetRelay$Widget(props) {
  let match = usePagination(props.query);
  let isLoadingNext = match.isLoadingNext;
  let hasNext = match.hasNext;
  let loadNext = match.loadNext;
  let data = match.data;
  let items = getConnectionNodes(data.accountClientsV5);
  let connectionId = Stdlib_Option.map(data.accountClientsV5, param => param.__id);
  if (items.length === 0) {
    return JsxRuntime.jsx(MyClientsWidgetRelay$EmptyState, {});
  }
  let tmp;
  tmp = props.viewMoreMode === "ShowAllButton" ? (
      hasNext ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ReadMoreButton.make, {
            href: "/my_clients",
            children: "View All"
          }),
          className: "mt-4"
        }) : null
    ) : (
      hasNext && !isLoadingNext ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
            onClick: param => {
              loadNext(30, undefined);
            },
            className: "w-full",
            children: "See More Clients"
          }),
          className: "mt-4"
        }) : null
    );
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx("ul", {
        children: items.map(item => {
          switch (item.__typename) {
            case "Buyer" :
              return JsxRuntime.jsx(MyClientsWidgetBuyer.make, {
                buyer: item.fragmentRefs,
                connectionId: connectionId
              }, item.id);
            case "Landlord" :
              return JsxRuntime.jsx(MyClientsWidgetLandlord.make, {
                landlord: item.fragmentRefs,
                connectionId: connectionId
              }, item.id);
            case "Renter" :
              return JsxRuntime.jsx(MyClientsWidgetRenter.make, {
                renter: item.fragmentRefs,
                connectionId: connectionId
              }, item.id);
            case "Seller" :
              return JsxRuntime.jsx(MyClientsWidgetSeller.make, {
                seller: item.fragmentRefs,
                connectionId: connectionId
              }, item.id);
            case "__unselected" :
              return null;
          }
        }),
        className: "flex flex-col border-b mb-6 divide-y border-t"
      }),
      tmp,
      isLoadingNext ? JsxRuntime.jsx(Loader.make, {}) : null
    ]
  });
}

let Widget = {
  make: MyClientsWidgetRelay$Widget
};

function MyClientsWidgetRelay(props) {
  return JsxRuntime.jsx(MyClientsWidgetRelay$Layout, {
    children: JsxRuntime.jsx(React.Suspense, {
      children: JsxRuntime.jsx(MyClientsWidgetRelay$Widget, {
        query: props.query,
        viewMoreMode: props.viewMoreMode
      }),
      fallback: JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Loader.make, {
          loadingText: "Loading clients..."
        }),
        className: "h-[542.5px] flex items-center justify-center"
      })
    })
  });
}

let Landlord;

let Seller;

let Buyer;

let Renter;

let make = MyClientsWidgetRelay;

exports.Landlord = Landlord;
exports.Seller = Seller;
exports.Buyer = Buyer;
exports.Renter = Renter;
exports.AddClientMenu = AddClientMenu;
exports.QueryFragment = QueryFragment;
exports.Layout = Layout;
exports.EmptyState = EmptyState;
exports.Widget = Widget;
exports.make = make;
/* Hooks Not a pure module */
